import _classCallCheck from "D:\\Projects\\SourceCode\\MOHAP\\BS.MOHAP.Webchat\\BS.MOHAP.Webchat\\main\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { ArgumentNullError } from "../common/Exports";
import { AuthInfo } from "./IAuthentication";
var AuthHeader = "Authorization";
export var CognitiveTokenAuthentication = function CognitiveTokenAuthentication(fetchCallback, fetchOnExpiryCallback) {
  var _this = this;

  _classCallCheck(this, CognitiveTokenAuthentication);

  this.fetch = function (authFetchEventId) {
    return _this.privFetchCallback(authFetchEventId).onSuccessContinueWith(function (token) {
      return new AuthInfo(AuthHeader, token);
    });
  };

  this.fetchOnExpiry = function (authFetchEventId) {
    return _this.privFetchOnExpiryCallback(authFetchEventId).onSuccessContinueWith(function (token) {
      return new AuthInfo(AuthHeader, token);
    });
  };

  if (!fetchCallback) {
    throw new ArgumentNullError("fetchCallback");
  }

  if (!fetchOnExpiryCallback) {
    throw new ArgumentNullError("fetchOnExpiryCallback");
  }

  this.privFetchCallback = fetchCallback;
  this.privFetchOnExpiryCallback = fetchOnExpiryCallback;
};